import React, {Component} from 'react';

class Teamitem extends Component {
    render() {
        var {teamImage, memberN, memberd, role, url1, url2, url3, url4} = this.props;
        return (
            <div className="ex_team_item">
                <img src={require("../../img/teams/" + teamImage)} alt="team"/>
                <div className="team_content">
                    <a>
                        <h3 className="f_p f_size_16 f_600 t_color3">{memberN}</h3>
                    </a>
                    <h5>{role}</h5>
                </div>
                <div className="hover_content">
                    <div className="n_hover_content">
                        <ul className="list-unstyled">
                                <li><a href={url1} target="_blank" rel="noopener noreferrer"><i className="ti-facebook" /></a></li>
                                <li><a href={url2} target="_blank" rel="noopener noreferrer"><i className="ti-linkedin" /></a></li>
                                <li><a href={url3} target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt" /></a></li>
                                <li><a href={url4} target="_blank" rel="noopener noreferrer"><i className="ti-instagram" /></a></li>
                        </ul>
                        <div className="br"/>
                        <a>
                            <h3 className="f_p f_size_16 f_600 w_color">{memberN}</h3>
                        </a>
                        <h5>{memberd}</h5>
                    </div>
                </div>
            </div>
        )
    }
}

export default Teamitem;
